export const getUserSolutions = state => state.solutions.userSolutions;